export function NotFoundPage(): void {
    const app = document.getElementById('app');
    if (!app) return;

    app.innerHTML = `
        <div class="container">
            <header class="header">
                <h1>Mediabin</h1>
            </header>
            <main class="main">
                <div class="error-page">
                    <h2>404 — Not Found</h2>
                    <p>The paste you're looking doesn't exist or has expired.</p>
                    <a href="/" class="btn btn-primary">Create a new paste</a>
                </div>
            </main>
        </div>
    `;
}
